import { render, staticRenderFns } from "./CardArquivo.vue?vue&type=template&id=6c54f595&"
import script from "./CardArquivo.js?vue&type=script&lang=js&"
export * from "./CardArquivo.js?vue&type=script&lang=js&"
import style0 from "./CardArquivo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QColor from 'quasar/src/components/color/QColor.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QColor});
